export const lineBreaker = (str: string, lengthToBreak = 30): string => {
  if (str.length > lengthToBreak) {
    const index = str.length / 2;
    return `${str.slice(0, index)}\n${str.slice(index)}`;
  }
  return str
}
